export default () => ({
    subHeader: {
        marginTop: 30,
    }
});